import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M.75 2.5h22.5m-2.5 3H3.25c-.552 0-1 .372-1 .83v3.34c0 .458.448.83 1 .83h17.5c.552 0 1-.372 1-.83V6.33c0-.458-.448-.83-1-.83Zm0 8H3.25c-.552 0-1 .372-1 .83v3.34c0 .458.448.83 1 .83h17.5c.552 0 1-.372 1-.83v-3.34c0-.458-.448-.83-1-.83Zm-20 8h22.5",
		stroke: "#000",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M.75%202.5h22.5m-2.5%203H3.25c-.552%200-1%20.372-1%20.83v3.34c0%20.458.448.83%201%20.83h17.5c.552%200%201-.372%201-.83V6.33c0-.458-.448-.83-1-.83Zm0%208H3.25c-.552%200-1%20.372-1%20.83v3.34c0%20.458.448.83%201%20.83h17.5c.552%200%201-.372%201-.83v-3.34c0-.458-.448-.83-1-.83Zm-20%208h22.5%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
